<div class="modalGallery" [class.open]="showGallery">
  <div class="modalGallery__cont">
    <div class="modalGallery__close" (click)="toggleShowGallery()">
      <app-ds-button
      [type]="buttonType.Secondary"
      [showIcon]="true"
      [icon]="icon.Close"
      [labels]="{ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.CLOSE' | transloco }"
    ></app-ds-button>
    </div>
    <div class="modalGallery__columns">
      <div class="modalGallery__columns--left">
        <app-ds-button-icon
          [icon]="icon.ChevronLeft"
          [buttonSize]="buttonIconSize.LG"
          (clickEvent)="previousImage()">
        </app-ds-button-icon>
      </div>
      <div class="modalGallery__columns--center">
        <app-ds-image
          [src]="selectedImage"
          [width]="'auto'"
          [height]="'100%'"
          [objectFit]="false"
          [size]="imageSize">
        </app-ds-image>
      </div>
      <div class="modalGallery__columns--right">
        <app-ds-button-icon
          [icon]="icon.ChevronRight"
          [buttonSize]="buttonIconSize.LG"
          (clickEvent)="nextImage()">
        </app-ds-button-icon>
      </div>
    </div>
    
    <div class="modalGallery__imageCount">
      <app-ds-typography
        [size]="fontSize.SM"
        [color]="fontColor.Invert"
        [fontFamily]="fontFamily.Regular"
        [text]="imagesCount">
      </app-ds-typography>
    </div>
    
    <div class="modalGallery__imageList">
      <div class="modalGallery__imageList--arrowLeft" (click)="previousImages()">
        <app-ds-icon [icon]="icon.ChevronLeft" [color]="iconColor.Light"></app-ds-icon>
      </div>
      <div class="modalGallery__imageList--images" #imagesContent>
        <div class="image" *ngFor="let image of images;let i=index">
          <app-ds-image
            (click)="selectImage(i)"
            [src]="image"
            [width]="'171px'"
            [height]="'120px'"
            [objectFit]="true"
            [size]="imageSize">
          </app-ds-image>
        </div>
      </div>
      <div class="modalGallery__imageList--arrowRight" (click)="nextImages()">
        <app-ds-icon [icon]="icon.ChevronRight" [color]="iconColor.Light"></app-ds-icon>
      </div>
    </div>
  </div>
  <div class="background" (click)="toggleShowGallery()"></div>
</div>